var exports = {
  "b": "EdgeProximitySensor.module__sensorLeftEdge___VGtkaG",
  "O": "EdgeProximitySensor.module__sensorRightEdge___VGtkaG",
};

module.exports = exports;
